import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import { connectToChat } from '../utils/socketUtils';
import { IS_ADMIN } from '../utils/userBORoleUtils';

const SocketContext = createContext(null);

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({
  token,
  onMessage,
  onReadMessage,
  children,
}) => {
  const [socket, setSocket] = useState(null);
  const isAdmin = IS_ADMIN();
  const onMessageRef = useRef(onMessage);
  const onReadMessageRef = useRef(onReadMessage);

  // Keep callbacks fresh without reconnecting the socket
  useEffect(() => {
    onMessageRef.current = onMessage;
    onReadMessageRef.current = onReadMessage;
  }, [onMessage, onReadMessage]);

  useEffect(() => {
    if (!isAdmin || !token) return;

    const newSocket = connectToChat(
      token,
      msg => onMessageRef.current?.(msg),
      msg => onReadMessageRef.current?.(msg),
    );

    setSocket(newSocket);

    return () => {
      newSocket?.disconnect();
      setSocket(null);
    };
  }, [isAdmin, token]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};
